import React, { useState } from 'react'
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    IconButton,
    Tabs,
    Tab,
    Button,
    AppBar,
    Toolbar,
    LinearProgress,
    Dialog,
    DialogContent,
    Slide,
    Badge,
    CircularProgress,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'
import BugReportIcon from '@mui/icons-material/BugReport'
import MapIcon from '@mui/icons-material/Map'
import InfoIcon from '@mui/icons-material/Info'
import CloseIcon from '@mui/icons-material/Close'
import MessageIcon from '@mui/icons-material/Message'
import NavigateBefore from '@mui/icons-material/NavigateBefore'
import NavigateNext from '@mui/icons-material/NavigateNext'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import dayjs from 'dayjs'
import InverterViewGraph from './InverterViewGraph/InverterViewGraph'
import TechnicalViewGraph from './TechnicalViewGraph/TechnicalViewGraph'
import EnergyAnalysisGraph from './EnergyAnalysisGraph/EnergyAnalysisGraph'
import LiveDataView from './LiveDataView/LiveDataView'
import EnergyIcon from '@mui/icons-material/ElectricBolt'
import SolarPowerIcon from '@mui/icons-material/SolarPower'
import YieldIcon from '@mui/icons-material/Brightness6'
import Co2Icon from '@mui/icons-material/Co2'
import MicrowaveIcon from '@mui/icons-material/Microwave'
import PlantDetailsContent from './PlantDetailsDialog/PlantDetailsContent'
import RawDataDownload from './RawData/RawDataDownload'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const KPICard = ({ title, value, unit, icon, color }) => (
    <Card sx={{
        height: '100%',
        borderRadius: '16px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        border: '1px solid #f0f0f0'
    }}>
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Box sx={{
                    p: 1,
                    borderRadius: '10px',
                    bgcolor: `${color}15`,
                    color: color,
                    display: 'flex',
                    mr: 1.5
                }}>
                    {icon}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {title}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a' }}>{value}</Typography>
                <Typography variant="caption" sx={{ ml: 0.5, fontWeight: 500, color: 'text.secondary' }}>{unit}</Typography>
            </Box>
        </CardContent>
    </Card>
)

const PlantTechnicalViewMobileView = ({ logic, permissions }) => {
    const navigate = useNavigate()
    const [openDetails, setOpenDetails] = useState(false)
    const {
        plantContent,
        liveData,
        hourGlassValue,
        issueCount,
        liveTabActive,
        setLiveTabActive,
        handleIssueManagement,
        handlePlantMapView,
        notifications,
        notificationCount,
        loading,
        page,
        setPage,
        totalPages,
        showNotifications,
        setShowNotifications,
        selectedNotification,
        setSelectedNotification,
        activeTab,
        setActiveTab,
        markNotificationAsRead,
        markNotificationAsDone,
        markCurrentNotificationAsDone,
        handleOpenEdit,
        handleDeleteplant,
        dleted,
        setdelete,
        state,
        token
    } = logic

    const { is, can } = permissions

    return (
        <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh', pb: 4 }}>
            {/* Mobile App Bar */}
            <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#fff', borderBottom: '1px solid #eee' }}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton edge="start" color="inherit" onClick={() => navigate(-1)} sx={{ color: '#333', mr: 1 }}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a1a', lineHeight: 1.2 }}>
                                {plantContent?.plantName}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {plantContent?.projectCode}
                            </Typography>
                        </Box>
                    </Box>
                    <IconButton sx={{ color: '#333' }} onClick={() => setOpenDetails(true)}>
                        <InfoIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Tenue Progress */}
            <Box sx={{ px: 2, mt: 2, mb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>Plant Tenure Progress</Typography>
                    <Typography variant="caption" sx={{ fontWeight: 700 }}>{Math.round(hourGlassValue || 0)}%</Typography>
                </Box>
                <LinearProgress
                    variant="determinate"
                    value={hourGlassValue || 0}
                    sx={{
                        height: 8,
                        borderRadius: 4,
                        bgcolor: '#e0e0e0',
                        '& .MuiLinearProgress-bar': { borderRadius: 4, bgcolor: '#4caf50' }
                    }}
                />
            </Box>

            {/* KPI Grid */}
            <Box sx={{ px: 2, mb: 3 }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <KPICard
                            title="Daily Energy"
                            value={liveData?.dailyEnergyMFM || '—'}
                            unit="kWh"
                            icon={<EnergyIcon fontSize="small" />}
                            color="#2196f3"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <KPICard
                            title="Inverter E. Today"
                            value={liveData?.inverterEToday || '—'}
                            unit="kWh"
                            icon={<MicrowaveIcon fontSize="small" />}
                            color="#ff9800"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <KPICard
                            title="Irradiance"
                            value={liveData?.gtiValue || '—'}
                            unit="kWh/m²"
                            icon={<SolarPowerIcon fontSize="small" />}
                            color="#03a9f4"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <KPICard
                            title="Specific Yield"
                            value={liveData?.specificYield || '—'}
                            unit="kWh/kWp"
                            icon={<YieldIcon fontSize="small" />}
                            color="#4caf50"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <KPICard
                            title="CO2 Avoided"
                            value={liveData?.co2Avoided || '—'}
                            unit="Tonnes"
                            icon={<Co2Icon fontSize="small" />}
                            color="#8bc34a"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{
                            borderRadius: '16px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            border: '1px solid #f0f0f0',
                            bgcolor: '#fff',
                            cursor: 'pointer'
                        }} onClick={() => setShowNotifications(true)}>
                            <CardContent sx={{ p: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{
                                            p: 1,
                                            borderRadius: '10px',
                                            bgcolor: '#5968B715',
                                            color: '#5968B7',
                                            display: 'flex',
                                            mr: 1.5
                                        }}>
                                            <MessageIcon fontSize="small" />
                                        </Box>
                                        <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Notifications
                                        </Typography>
                                    </Box>
                                    {notificationCount > 0 && (
                                        <Badge badgeContent={notificationCount} color="error" />
                                    )}
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    fontWeight: 500
                                }}>
                                    {notifications.length > 0 ? notifications[0].message : 'No new notifications'}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            {/* Quick Actions */}
            <Box sx={{ display: 'flex', px: 2, gap: 1, mb: 3 }}>
                {/* Issues */}
                {(is('Super Admin') || is('Admin') || is('Asset Management') || can('issue.all') || can('issue.read')) && (
                    <Box
                        onClick={handleIssueManagement}
                        sx={{
                            flex: 1,
                            bgcolor: '#d32f2f',
                            color: '#fff',
                            borderRadius: '8px',
                            height: '48px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(211, 47, 47, 0.2)',
                            cursor: 'pointer',
                            '&:hover': { bgcolor: '#b71c1c' }
                        }}
                    >
                        <Badge badgeContent={issueCount} color="warning" sx={{ '& .MuiBadge-badge': { fontWeight: 700 } }}>
                            <BugReportIcon />
                        </Badge>
                    </Box>
                )}

                {/* Dashboard data Download */}
                {(is('Super Admin') || is('Admin') || is('Asset Management') || can('plant.all') || can('plant.create')) && (
                    <Box sx={{
                        flex: 1,
                        borderRadius: '8px',
                        bgcolor: '#1976d2',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
                        '& .rawDataDownloadMobile': {
                            width: '100%',
                            height: '100%',
                            color: '#fff',
                            borderRadius: '8px'
                        }
                    }}>
                        <RawDataDownload plantData={plantContent} state={state} isIconButton />
                    </Box>
                )}



                {/* Map View */}
                <Box
                    onClick={handlePlantMapView}
                    sx={{
                        flex: 1,
                        bgcolor: '#2e7d32',
                        color: '#fff',
                        borderRadius: '8px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(46, 125, 50, 0.2)',
                        cursor: 'pointer',
                        '&:hover': { bgcolor: '#1b5e20' }
                    }}
                >
                    <MapIcon />
                </Box>
            </Box>

            {/* Main Content Tabs */}
            <Box sx={{ bgcolor: '#fff', borderTop: '1px solid #eee', pt: 1 }}>
                <Tabs
                    value={liveTabActive}
                    onChange={(e, v) => setLiveTabActive(v)}
                    variant="fullWidth"
                    sx={{ borderBottom: '1px solid #f0f0f0' }}
                >
                    <Tab label="Graphs" value="graphs" sx={{ textTransform: 'none', fontWeight: 600 }} />
                    <Tab label="Live Data" value="live" sx={{ textTransform: 'none', fontWeight: 600 }} />
                </Tabs>

                <Box sx={{ p: 2 }}>
                    {liveTabActive === 'graphs' && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <Box>
                                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: '#444' }}>Generation Over Time</Typography>
                                <Box sx={{ width: '100%' }}>
                                    <TechnicalViewGraph state={state?.data} plantContent={plantContent} token={token} />
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: '#444' }}>Inverter Performance</Typography>
                                <Box sx={{ width: '100%' }}>
                                    <InverterViewGraph state={state?.data} plantContent={plantContent} token={token} />
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: '#444' }}>Energy Analysis</Typography>
                                <Box sx={{ width: '100%' }}>
                                    <EnergyAnalysisGraph state={state?.data} plantContent={plantContent} token={token} />
                                </Box>
                            </Box>
                        </Box>
                    )}

                    {liveTabActive === 'live' && (
                        <LiveDataView plantData={plantContent} token={token} />
                    )}
                </Box>
            </Box>

            {/* Plant Details Dialog */}
            <Dialog
                fullScreen
                open={openDetails}
                onClose={() => setOpenDetails(false)}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: '#fff', color: '#333', boxShadow: 'none', borderBottom: '1px solid #eee' }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={() => setOpenDetails(false)}>
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1, fontWeight: 700 }} variant="h6">
                            Plant Details
                        </Typography>
                        <Box sx={{ display: 'flex' }}>
                            {can("plant.update") && (
                                <IconButton color="inherit" onClick={handleOpenEdit}>
                                    <EditIcon />
                                </IconButton>
                            )}
                            {can("plant.delete") && (
                                <IconButton color="error" onClick={() => setdelete(true)}>
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </Box>
                    </Toolbar>
                </AppBar>
                <DialogContent sx={{ p: 0 }}>
                    <PlantDetailsContent
                        plantData={plantContent}
                        dleted={dleted}
                        handleCloseDelete={() => setdelete(false)}
                        handleDeleteplant={handleDeleteplant}
                    />
                </DialogContent>
            </Dialog>

            {/* Notifications Dialog */}
            <Dialog
                fullScreen
                open={showNotifications}
                onClose={() => { setShowNotifications(false); setSelectedNotification(null); }}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: '#fff', color: '#333', boxShadow: 'none', borderBottom: '1px solid #eee' }}>
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton edge="start" color="inherit" onClick={() => { setShowNotifications(false); setSelectedNotification(null); }}>
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, fontWeight: 700 }} variant="h6">
                                Notifications
                            </Typography>
                        </Box>
                        {!selectedNotification && (
                            <Tabs
                                value={activeTab}
                                onChange={(e, v) => { setActiveTab(v); setPage(1); }}
                                sx={{ '& .MuiTab-root': { minWidth: 70, fontSize: '0.8rem' } }}
                            >
                                <Tab label="Unread" value="unread" />
                                <Tab label="Read" value="read" />
                            </Tabs>
                        )}
                    </Toolbar>
                </AppBar>
                <DialogContent sx={{ p: 2 }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={30} /></Box>
                    ) : selectedNotification ? (
                        <Box>
                            <IconButton onClick={() => setSelectedNotification(null)} sx={{ mb: 2 }}><NavigateBefore /></IconButton>
                            <Box sx={{ p: 1 }}>
                                <Typography variant="h6" sx={{ fontWeight: 700 }}>{selectedNotification.plantName}</Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                    {dayjs(selectedNotification.created_at).format('DD MMM YYYY | HH:mm')}
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 3 }}>{selectedNotification.message}</Typography>
                                {!selectedNotification.isDone && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        startIcon={<CheckCircleOutlineIcon />}
                                        onClick={markCurrentNotificationAsDone}
                                        sx={{ borderRadius: '12px', py: 1.5 }}
                                    >
                                        Mark as Done
                                    </Button>
                                )}
                                {selectedNotification.isDone && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', color: '#4caf50', gap: 1 }}>
                                        <CheckCircleOutlineIcon />
                                        <Typography variant="body2">Completed on {dayjs(selectedNotification.doneAt).format('DD MMM YYYY')}</Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    ) : notifications.length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {notifications.map((notification) => (
                                <Card
                                    key={notification.id}
                                    sx={{
                                        borderRadius: '12px',
                                        borderLeft: `4px solid ${notification.status === 'unread' ? '#1976d2' : '#ddd'}`,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                    }}
                                    onClick={() => notification.status === 'unread' ? markNotificationAsRead(notification) : setSelectedNotification(notification)}
                                >
                                    <CardContent sx={{ p: 2 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{notification.plantName}</Typography>
                                            <Typography variant="caption" color="text.secondary">{dayjs(notification.created_at).format('DD MMM | HH:mm')}</Typography>
                                        </Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{notification.message}</Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                            {!notification.isDone ? (
                                                <Button
                                                    size="small"
                                                    variant="text"
                                                    startIcon={<CheckCircleOutlineIcon />}
                                                    onClick={(e) => { e.stopPropagation(); markNotificationAsDone(notification, e); }}
                                                >
                                                    Mark Done
                                                </Button>
                                            ) : (
                                                <Typography variant="caption" color="success.main" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <CheckCircleOutlineIcon fontSize="inherit" /> Done
                                                </Typography>
                                            )}
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                            {totalPages > 1 && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mt: 2 }}>
                                    <IconButton disabled={page === 1} onClick={() => setPage(p => p - 1)}><NavigateBefore /></IconButton>
                                    <Typography variant="caption">{page} / {totalPages}</Typography>
                                    <IconButton disabled={page === totalPages} onClick={() => setPage(p => p + 1)}><NavigateNext /></IconButton>
                                </Box>
                            )}
                        </Box>
                    ) : (
                        <Box sx={{ textAlign: 'center', py: 8 }}>
                            <Typography color="text.secondary">No {activeTab} notifications</Typography>
                        </Box>
                    )}
                </DialogContent>
            </Dialog>
        </Box >
    )
}

export default PlantTechnicalViewMobileView
